import { RunLogTablePanel } from "#src/batteries-included-components";
import { RunLogFilterArea } from "#src/batteries-included-components/FilterAreas/RunLogFilterAreas/RunLogFilterAreas";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Page } from "@validereinc/common-components";
import React from "react";
import { RunLogRoutePath } from ".";
import { useSearchParams } from "#src/Routers/hooks";
import { produce } from "immer";

export const RunLogListPage = () => {
  const [viewConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["view-configuration", "table-configuration", "table-state"],
      "run-log"
    );
  const [breadcrumbs] = useBreadcrumbsFromRoute(RunLogRoutePath);
  const [searchParams, setSearchParams] = useSearchParams<{
    job_id?: string;
  }>();

  const { job_id } = searchParams;

  return (
    <Page
      title={RunLogRoutePath.title}
      breadcrumbs={breadcrumbs}
    >
      <RunLogFilterArea viewConfigStorageKey={viewConfigStorageKey} />
      <RunLogTablePanel
        viewConfigStorageKey={viewConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
        defaultJobId={job_id}
        onJobSelection={(id) => {
          setSearchParams(
            produce(searchParams, (draft) => {
              if (id) draft.job_id = id;
              else delete draft.job_id;
            })
          );
        }}
      />
    </Page>
  );
};
